module.exports = __webpack_public_path__ + "img/color-wheel (1).5c2b145b.png";